import React from 'react';
import styled from 'styled-components';
import PropTypes, { object } from 'prop-types';
import { connect } from 'react-redux';
import SSOLogin from '../../common/signInSignUp/ssoLogin';
import Actions from '../../../store/actions';
import universityDomains from '../../../utility/universityDomain';
import userInfoController from '../../../utility/userInfoController';
import getToken from '../../../utility/getToken';

const Wrapper = styled.div`
  display: grid;
  align-items: center;
  grid-column-gap: 1rem;
  grid-template-columns: auto 1fr 1fr auto;
  div {
    grid-row: 1;
    grid-column: 2/5;
  }
`;

const Span = styled.span`
  font-weight: 500;
  grid-row: 1;
  grid-column: 1/2;
`;

const Select = styled.select``;

export const getUniversityPlan = async (email, universityCode, userId) => {
  let universityDetails = null;
  const token = await getToken();
  const res = await userInfoController.checkUniversityLicense(
    { university: universityCode, userEmail: email, userId },
    token,
  );
  if (res.data.status) {
    if (
      res.data.userType === 'admin' ||
      res.data.userType === 'advisor' ||
      res.data.userType === 'root'
    ) {
      // set premium + review plan
      universityDetails = {
        userType: res.data.userType,
        plan: 'Premium&Review',
        code: universityCode,
        organizationDetails: res.data.organizationDetails,
      };
    } else {
      // set premium plan
      universityDetails = {
        userType: res.data.userType,
        plan: 'Premium',
        code: universityCode,
        organizationDetails: res.data.organizationDetails,
      };
    }

    universityDetails = {
      ...universityDetails,
      organizationIdentity: res?.data?.organizationIdentity,
    };
  }
  return universityDetails;
};

/**
 *
 * TODO: Need to change the universityDomains and email.split logic
 * when we use this component.
 */

const UniversityAuth = (props) => {
  const {
    universityLinked,
    activePlan,
    user,
    subscriptionStatus,
    universityPlan,
    updateUserInfo,
    selectedPlanRedux,
  } = props;
  const {
    profile: { sub, email },
  } = user;
  const isUniversityEmail = email && universityDomains[email.split('@')[1]];
  const provider = localStorage.getItem('sp');
  const ssoSignIn =
    localStorage.getItem('sign-in-method') === `SSO-${provider}`;

  const handlePlanChange = (e) => {
    // set the selected plan in localstorage and redux
    const selectedOption = e.target.value;

    localStorage.setItem(`selectedPlan-${sub}`, selectedOption);

    updateUserInfo({
      selectedPlan: selectedOption,
    });
  };
  return (
    <>
      <Wrapper>
        {isUniversityEmail && !ssoSignIn && (
          <>
            <Span>Link account with your university</Span>
            <SSOLogin universityAuth={email.split('@')[1]} />
          </>
        )}
      </Wrapper>
      {universityLinked && universityPlan && (
        <div>
          Select Plan
          <Select onChange={handlePlanChange} data-testid="plan-dropdown">
            <option
              value="usersPlan"
              selected={selectedPlanRedux === 'usersPlan'}
              data-testid="select-option"
            >
              {activePlan && subscriptionStatus ? activePlan.name : 'Free'}
            </option>
            <option
              value="universityPlan"
              selected={selectedPlanRedux === 'universityPlan'}
              data-testid="select-option"
            >
              {universityPlan.plan}
            </option>
          </Select>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  universityLinked: state.userInfoReducer.universityLinked,
  activePlan: state.userInfoReducer.activePlan,
  universityPlan: state.userInfoReducer.universityPlan,
  subscriptionStatus: state.userInfoReducer.subscriptionStatus,
  selectedPlanRedux: state.userInfoReducer.selectedPlan,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getUserInfo: (...params) => {
    dispatch(Actions.userInfoActions.getUserInfo(...params));
  },
  updateUserInfo: (...params) => {
    dispatch(Actions.userInfoActions.updateUserInfo(...params));
  },
});
UniversityAuth.propTypes = {
  activePlan: PropTypes.shape(object).isRequired,
  subscriptionStatus: PropTypes.bool.isRequired,
  universityLinked: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  selectedPlanRedux: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UniversityAuth);
